import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    svgHover: {
        fill: theme.palette.foreground.default,
        "&:hover": {
            fill: "#6878a9",
        },
        transition: "all 0.5s ease",
    },
}));

export const Logo = ({className}) => {
    const classes = useStyles();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 429 430"
            className={`${classes.svgHover} ${className}`}
        >
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_5" data-name="Layer 5">
                    <g transform="translate(0.000000,430.000000) scale(0.100000,-0.100000)"
                       stroke="none">
                        <path d="M1652 3693 c-22 -49 -57 -124 -77 -168 -20 -44 -47 -102 -60 -130
-12 -27 -57 -126 -100 -220 -42 -93 -88 -195 -102 -225 -14 -30 -59 -129 -100
-220 -41 -91 -89 -196 -107 -235 -18 -38 -50 -108 -72 -155 -56 -124 -139
-254 -183 -289 -42 -34 -109 -61 -147 -61 -13 0 -24 -6 -24 -12 0 -10 77 -13
350 -13 207 0 350 4 350 10 1 5 -27 15 -61 22 -127 26 -188 75 -209 168 -18
79 2 152 102 366 l42 89 355 -1 356 0 59 -120 c32 -65 62 -119 65 -119 4 0 27
28 51 62 25 34 72 98 104 142 l59 81 -137 270 c-76 148 -203 399 -283 558
-173 341 -167 336 -231 200z m103 -665 c85 -169 155 -312 155 -318 0 -7 -101
-10 -305 -10 -219 0 -305 3 -305 11 0 11 34 90 105 244 18 39 65 143 105 233
41 89 77 159 82 154 4 -4 77 -145 163 -314z"/>
                        <path d="M2988 3174 c-67 -97 -139 -199 -159 -227 -19 -29 -95 -137 -169 -242
-74 -104 -154 -220 -179 -256 -98 -140 -128 -183 -181 -257 -31 -42 -81 -113
-111 -157 -31 -44 -147 -210 -259 -370 -112 -159 -227 -323 -254 -362 -50 -71
-80 -115 -200 -284 -173 -246 -170 -241 -150 -256 10 -7 23 -12 29 -10 5 2 41
49 80 104 63 90 198 284 494 703 52 74 128 182 168 240 41 58 112 159 158 225
46 66 110 156 140 200 31 44 83 118 116 165 33 47 82 117 109 155 27 39 73
104 102 146 29 41 105 148 168 238 63 89 126 179 140 199 14 20 49 70 77 111
29 40 50 77 47 82 -3 5 -13 13 -24 19 -16 8 -34 -13 -142 -166z"/>
                        <path d="M2771 2308 l-121 -181 0 -617 c0 -375 -4 -638 -10 -671 -6 -29 -20
-63 -31 -75 -21 -23 -94 -44 -149 -44 -20 0 -30 -5 -30 -15 0 -13 48 -15 375
-15 309 0 375 2 375 14 0 9 -20 15 -62 20 -77 8 -119 32 -135 76 -15 44 -18
1507 -3 1559 16 59 44 79 126 92 50 8 74 16 74 25 0 11 -29 14 -144 14 l-144
0 -121 -182z"/>
                    </g>
                </g>
            </g>
        </svg>
    );
};